<template>
<!-- 当前积分页 -->
    <div>
        <div class="banner">
            <img src="../assets/icon_qian@2x.png" alt="积分图标">
          <p>当前积分</p>
          <p style="color: #c34a45">（ 积分兑换功能暂未开放 ）</p>
            <p>{{ integral ? integral : 0 }}分</p>
            <p>可抵扣购物金额<span>{{ deductionMoney }}</span>元</p>
        </div>

        <div class="container">
            <div class="cardBox">
                <p @click="go_get_rule">
                    <span>积分获取规则</span>
                    <span>
                        <img src="../assets/icon_fanhui@2x.png" alt="more">
                    </span>
                </p>

                <p @click="to_expect">
                    <span>积分使用</span>
                    <span>
                        <img src="../assets/icon_fanhui@2x.png" alt="more">
                    </span>
                </p>

                <p @click="to_expect">
                    <span>获取积分详情</span>
                    <span>
                        <img src="../assets/icon_fanhui@2x.png" alt="more">
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

export default {
    data() {
        return {
            integral: '0',
            deductionMoney: '0'
        };
    },
    created() {
        this.getIntegral()
    },
    methods: {
        getIntegral() {
            this.axios.get('/weixin/toFirstPage')
            .then((response)=>{
                this.integral = response.data.credit;
                this.deductionMoney = this.accMul(this.integral, 0.001).toFixed(3)
            })
        },

        // 相乘
        accMul(arg1,arg2){
            var m=0,
                s1=arg1.toString(),
                s2=arg2.toString();
                try{m+=s1.split(".")[1].length}catch(e){}
                try{m+=s2.split(".")[1].length}catch(e){}
                return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
        },

        // 去积分规则
        go_get_rule() {
            this.$router.push({
                name: 'GetRules'
            })
        },

        // 去敬请期待
        to_expect() {
            this.$router.push({
                name: 'Expect'
            })
        },

    }
};
</script>

<style scoped>
body {
    font-family: "Helvetica";
    font-size: 40px;
    background: #f8f8f8;
    color: #343434;
}

p {
    margin: 0;
    padding: 0;

}

.banner {
    width: 100%;
    height: 390px;
    background: #7cd393;
    text-align: center;
    letter-spacing: 4px;
}

.banner img {
    width: 72px;
    margin: 44px 0 12px 0;
}

.banner p {
    font-size: 40px;
    color: #ffffff;
    margin-bottom: 8px;
}

.banner p span {
    color: #ffffff;
}

.banner p:nth-of-type(2) {
    font-size: 34px;
    font-weight: 600;
}

.banner p:last-child {
    font-size: 34px;
}

.container {
    padding: 28px 28px 0;
    letter-spacing: 4px;
}

.cardBox {
  background: #fff;
  padding: 0 28px;
  border-radius: 40px;
}

.cardBox p{
  display: flex;
  justify-content: space-between;
  height: 100px;
  line-height: 100px;
  border-bottom: 1px solid #f0f0f0;
}

.cardBox p:last-child {
  border-bottom: none;
}

.cardBox p span img {
    height: 28px;
}

.van-toast--html, .van-toast--text {
  min-width: 200px;
  min-height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/Integral.vue